import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import BrepLogo from "./BrepLogo";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props} aria-hidden="true">
    <path d="M19.6 8.32a6.34 6.34 0 0 1-3.71-1.19v7.72a5.79 5.79 0 1 1-5.79-5.79c.2 0 .4.01.6.03v2.53a3.27 3.27 0 1 0 2.28 3.11V2h2.44a3.9 3.9 0 0 0 3.86 3.42h.32z" />
  </svg>
);

const SITE_LINKS = [
  { to: "/services", label: "Services" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/coaches", label: "For Coaches" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/download", label: "Download App" },
];

const LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 mt-10" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <BrepLogo size="lg" withBars />
          <div className="mt-4 text-[12px] tracking-[0.28em] uppercase text-white/60">
            Every Rep. <span className="text-[#2A5BFF]">Better.</span>
          </div>
          <div className="mt-6 h-px w-24 bg-[#2A5BFF]" />
          <div className="mt-4 text-[10px] tracking-[0.3em] uppercase text-white/40">Powered by</div>
          <div className="text-[12px] tracking-[0.28em] uppercase text-[#2A5BFF] font-medium">
            Byron Performance Coaching
          </div>
          <p className="mt-6 text-white/40 text-sm max-w-md">
            Expert coaching, one rep at a time. Pay per service, not per month.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.32em] uppercase text-white/40 mb-4">Site</div>
          <ul className="space-y-3 text-white/70 text-sm">
            {SITE_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[#2A5BFF] transition-colors" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] tracking-[0.32em] uppercase text-white/40 mb-4">Legal</div>
          <ul className="space-y-3 text-white/70 text-sm">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[#2A5BFF] transition-colors" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] tracking-[0.32em] uppercase text-white/40 mb-4">Follow</div>
          <div className="flex items-center gap-3 flex-wrap">
            <a href="#" aria-label="Instagram" className="w-10 h-10 border border-white/15 hover:border-[#2A5BFF] hover:text-[#2A5BFF] flex items-center justify-center transition-colors" data-testid="footer-instagram">
              <Instagram size={18} />
            </a>
            <a href="#" aria-label="TikTok" className="w-10 h-10 border border-white/15 hover:border-[#2A5BFF] hover:text-[#2A5BFF] flex items-center justify-center transition-colors" data-testid="footer-tiktok">
              <TikTokIcon />
            </a>
            <a href="mailto:hello@thebrep.app" aria-label="Email" className="w-10 h-10 border border-white/15 hover:border-[#2A5BFF] hover:text-[#2A5BFF] flex items-center justify-center transition-colors" data-testid="footer-email">
              <Mail size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-[11px] tracking-[0.2em] uppercase text-white/40">
          <span>© {new Date().getFullYear()} BRep. All rights reserved.</span>
          <span>Made for those who show up.</span>
        </div>
      </div>
    </footer>
  );
}
